import { render, staticRenderFns } from "./ModalRegraDeCalculoIncluirLocaisExecucao.vue?vue&type=template&id=31b423c8&scoped=true"
import script from "./ModalRegraDeCalculoIncluirLocaisExecucao.vue?vue&type=script&lang=ts"
export * from "./ModalRegraDeCalculoIncluirLocaisExecucao.vue?vue&type=script&lang=ts"
import style0 from "./ModalRegraDeCalculoIncluirLocaisExecucao.vue?vue&type=style&index=0&id=31b423c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b423c8",
  null
  
)

export default component.exports